export default "__VITE_ASSET__DUpF_mSi__"